export default __webpack_public_path__ + "static/media/back-app.f07a03b4.svg";